import { HStack as ChakraHStack } from "@chakra-ui/react";

export const HStack = ChakraHStack;
